<template>
  <page-layout
    :breadcrumbs="[
      {
        text: this.$t('navDrawer.home').toUpperCase(),
        disabled: false,
        to: {name: 'home'}, exact: true
      },
      {
        text: localization.title.toUpperCase(),
        disabled: true
      }
    ]"
  >
    <v-row justify="center" align="center" no-gutters>
      <v-col cols="12">
        <v-form v-model="valid" id="valid" ref="form">
          <o-big-title justify="start"><slot name="title">{{localization.datosVisita.title}}</slot></o-big-title>
          <v-row wrap align="center" justify="center" no-gutters>
            <v-col cols="12" md="3" lg="3" class="pl-3 pr-3">
              <v-autocomplete :no-data-text="$t('sinDatos')" v-model="promSelected" id="promSelected" :items="promosCliente"
                @change="generarInmuebles(promSelected)" item-value="id" clearable
                :label="$t('sectionNuevaVisita.datosVisita.promocion') + '*'" :rules="[rules.obligatorio]">
                  <template v-slot:selection="data">
                    {{ data.item.code }} - {{ data.item.name }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.code }} - {{ data.item.name }}
                  </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" class="pl-3 pr-3">
                <v-autocomplete :no-data-text="$t('sinDatos')" v-model="inmuebleSelected" id="inmuebleSelected"
                  :items="inmueblesCliente"
                  :label="$t('sectionNuevaVisita.datosVisita.inmuebles') + '*'"
                  item-value="ID_INMUEBLE"
                  :item-text="obtenerTextoInmueble"
                  :disabled="inmueblesCliente.length <= 0 || !promSelected"
                  :rules="[rules.obligatorio]" clearable
                  @change="getInmueblePropId(inmuebleSelected)" />
            </v-col>
            <v-col cols="12" md="3" lg="3" class="pl-3 pr-3">
              <v-autocomplete :no-data-text="$t('sinDatos')" v-model="tiposVisita" id="tiposVisita"
                :items="tiposVisitaArray" item-text="name"
                item-value="id" :rules="[rules.obligatorio]"
                :label="localization.datosVisita.tipoVisita  + '*'"
                clearable />
            </v-col>

            <v-col cols="12" md="3" lg="3" class="pl-3 pr-3">
              <v-autocomplete :no-data-text="$t('sinDatos')" v-model="TipoSolicitud" id="codigoTipoSolicitud"
                :items="tiposSolicitudesArray" item-text="descripcionTipoSolicitud"
                item-value="codigoTipoSolicitud" :rules="[rules.obligatorio]"
                :label="localization.datosVisita.tipoSolicitud  + '*'"
                clearable />
            </v-col>
          </v-row>

          <o-big-title justify="start"><slot name="title">{{localization.datosVisita.datosContacto}}</slot></o-big-title>
          <v-row>
            <v-col cols="12" md="3" lg="3">
              <v-text-field v-model="nombre" id="nombre"
                :label="$t('sectionNuevaVisita.datosVisita.nombre')"></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3">
              <v-text-field v-model="email" id="email"
                :label="$t('sectionNuevaVisita.datosVisita.email')"></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3">
              <v-text-field v-model="tlf" id="tlf"
                :label="$t('sectionNuevaVisita.datosVisita.telefono')"></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="3">
              <v-text-field v-model="contact" id="contact"
                :label="$t('sectionNuevaVisita.datosVisita.contacto')"></v-text-field>
            </v-col>
          </v-row>

          <o-big-title justify="start"><slot name="title">{{localization.datosVisita.titleSolicitud}}</slot></o-big-title>
          <v-row justify="center">
            <v-col cols="12" md="6" lg="6" class="pl-3 pr-3" v-if="getConfiguracion.mostrarOficioWeb">
              <v-autocomplete :no-data-text="$t('sinDatos')" v-model="oficioSelected" id="oficioSelected" :items="oficios"
                :label="$t('sectionNuevaVisita.datosVisita.oficios')"
                item-text="name" item-value="id" clearable></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" lg="6" class="pl-3 pr-3">
              <v-autocomplete :no-data-text="$t('sinDatos')" v-model="locationSelected" id="locationSelected" :items="getLocations"
                :label="$t('sectionNuevaVisita.datosVisita.localizaciones')"
                item-text="name" item-value="id" clearable
                :disabled="inmuebleSelected.length <= 0"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-btn class="pt-2 pb-2 mt-5 mb-5" @click="dialogImage = !dialogImage">{{localization.datosVisita.addPictures}}</v-btn>
          </v-row>

          <AddPicture v-model="dialogImage" id="dialogImage" @success="updateImagesToUpload()"/>

          <v-row v-if="previewUrl.length > 0">
            <v-col cols="12" md="3" lg="3" class="pl-3 pr-3" v-for="(item, i) in previewUrl" :key="'prerview-' + i">
              <v-card>
                <v-card-subtitle class="pb-0">{{ item.desc }}</v-card-subtitle>
                <v-card-text class="text--primary">
                  <v-img :src="item.pic" width="300" height="150" />
                </v-card-text>
                <v-card-actions>
                  <v-icon @click="remove(i)">mdi-delete</v-icon>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="10" lg="10" class="pl-3 pr-3">
              <v-textarea :disabled="rolCliente && bloquearCampoDescripcion" filled name="desc" :label="$t('sectionNuevaVisita.datosVisita.descripcion')  + (rolCliente && bloquearCampoDescripcion ? '' : '*')"
                v-model="description" id="description" :rules="rolCliente && bloquearCampoDescripcion ? [] : [rules.obligatorio]"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="10" lg="10" class="pl-3 pr-3">
              <v-textarea filled name="obs" :label="$t('sectionNuevaVisita.datosVisita.observaciones')  + '*'"
                v-model="observation" id="observation"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col justify="center" align="center">
        <v-btn color="primary" :disabled="!valid" @click="create()">Añadir</v-btn>
      </v-col>
    </v-row>
  </page-layout>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import rulesMixin from '@/components/generic/rules.js'
import AddPicture from './addPictureDialog'

export default {
  components: {
    AddPicture
  },
  mixins: [rulesMixin],
  data () {
    return {
      valid: false,
      oficioSelected: [],
      observations: null,
      inmuebleSelected: [],
      visitDate: moment().format('YYYY-MM-DD'),
      tiposVisita: null,
      promSelected: null,
      clienteSeleccionado: [],
      waitingForLoad: false,
      loader: null,
      description: '',
      observation: '',
      picture: null,
      imageBase64: '',
      carpetaId: '1',
      pictureDescription: '',
      promosCliente: [],
      inmueblesCliente: [],
      // tiposVisitaArray: [{'id':'47','code':'2','name':'Post-Venta'}],
      userStorage: null,
      nombre: '',
      email: '',
      tlf: '',
      contact: '',
      locationSelected: null,
      previewUrl: [],
      dialogImage: false,
      allPics: [],
      TipoSolicitud: null
    }
  },
  async mounted () {

    const datosIdubapi = JSON.parse(localStorage.idubapi)

    this.userStorage = JSON.parse(localStorage.usuario)
    this.promosCliente = datosIdubapi.promociones
    this.getVisitTypes()

    this.obtenerPromocionesTiposSolicitudCliente('WEB')
    await this.getTiposSolicitudes()

    if(this.tiposSolicitudesArray.length > 0) {
      this.TipoSolicitud = this.tiposSolicitudesArray[0].codigoTipoSolicitud
    }

    if (this.tiposVisitaArray.length === 1) {
      this.tiposVisita = this.tiposVisitaArray[0].id
    }
    if (this.promosCliente.length === 1) {
      this.promSelected = this.promosCliente[0].id
    }
    if (this.oficios.length === 1) {
      this.oficioSelected = this.oficios[0].id
    }
    if (this.getLocations.length === 1) {
      this.locationSelected = this.getLocations[0].id
    }

    this.generarInmuebles(this.promSelected)

    this.loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      canCancel: false,
      onCancel: this.onCancel
    })
    this.load()
  },
  computed: {
    ...mapGetters({
      getConfiguracion: 'configuracion/getConfiguracion',
      tiposSolicitud: 'configuracion/getTiposSolicitud',
      getTiposSolicitudCliente: 'configuracion/getTiposSolicitudCliente',
      getNewVisitId: 'incidencias/getNewVisitId',
      getNewIncidenceId: 'incidencias/getNewIncidenceId',
      getLocations: 'incidencias/getLocations',
      getIdVisitaCliente: 'incidencias/getIdVisitaCliente',
      getPromocionesTiposSolicitudClienteWeb: 'configuracion/getPromocionesTiposSolicitudClienteWeb'
    }),
    localization () {
      return this.$t('sectionNuevaVisita')
    },
    actualVisitId () {
      if (this.$store.state.incidencias.actualVisitId) {
        return this.$store.state.incidencias.actualVisitId
      }
      return null
    },
    visitDateFormated () {
      return (this.visitDate) ? moment(this.visitDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },
    oficios () {
      if (this.$store.state.incidencias.oficios) {
        return this.$store.state.incidencias.oficios
      }
      return []
    },
    imagesToUp () {
      if (this.$store.state.incidencias.imagesToUp) {
        return this.$store.state.incidencias.imagesToUp
      }
      return []
    },
    tiposVisitaArray() {
      if (this.$store.state.incidencias.tipoVisita) {
        return this.$store.state.incidencias.tipoVisita.filter(obj => obj.code === '2')
      }
      return []
    },
    tiposSolicitudesArray() {
      /*let tiposSolicitudes = []
      if (this.getPromocionesTiposSolicitudClienteWeb) {
        for (let key in this.getPromocionesTiposSolicitudClienteWeb) {
          // si key es el tipo de visita seleccionado
          // if (key == this.tiposVisita) {
            if (this.getPromocionesTiposSolicitudClienteWeb[key].includes(this.promSelected)) {
              tiposSolicitudes.push(this.tiposSolicitud.find(e => e.id === key))
            }
          // }
          
        }
        console.log(tiposSolicitudes)
        return tiposSolicitudes
        // return this.getPromocionesTiposSolicitudClienteWeb
      }
      */
      let tiposSolicitudStore = this.$store.state.configuracion.tiposSolicitud
      if (this.getPromocionesTiposSolicitudClienteWeb) {
        let tiposSolicitudes = []
        for (let key in this.getPromocionesTiposSolicitudClienteWeb) {
          if (this.getPromocionesTiposSolicitudClienteWeb[key].includes(this.promSelected)) {
            tiposSolicitudes.push(tiposSolicitudStore.find(e => e.codigoTipoSolicitud === key))
          }
        }
        return tiposSolicitudes
      } else {
        let tipos = tiposSolicitudStore.filter(item => {
          return item.habilitarClienteWeb
        })

        if(tipos.length == 0) {
          tipos = tiposSolicitudStore.filter(item => {
            return item.habilitar
          })
        }
        return tipos
      }
    },
    bloquearCampoDescripcion() {
      return this.getConfiguracion.PV_BLOQUEO_CAMPO_DESCRIPCION_WEB
    },
    rolCliente () {
      return this.$store.state.login.rolCliente
    }
  },
  methods: {
    remove(index) {
      //removes from preview array and upload array
      console.log('index:', index)
      this.allPics.splice(index, 1)
      this.previewUrl.splice(index, 1)
      console.log('allpics after delete: ', this.allPics)
      console.log('previewURL after delete: ', this.previewUrl)
    },
    updateImagesToUpload () {
      console.log(this.imagesToUp)
      this.previewUrl.push({
        pic: URL.createObjectURL(this.imagesToUp.picture),
        desc: this.imagesToUp.description
      })
      this.allPics.push(this.imagesToUp)
      console.log('url', this.previewUrl)
      console.log('allPics: ', this.allPics)
    },
    getInmueblePropId (inmuebleSelected) {
      console.log('inmueble selected: ', inmuebleSelected)
      const propTypeId = this.inmueblesCliente.find(e => {
        return e.ID_INMUEBLE === inmuebleSelected
      })
      console.log('ROOM PROP ID: ', propTypeId.ID_TIPO_INMUEBLE)
      this.getLocalizaciones(propTypeId.ID_TIPO_INMUEBLE)
    },
    generarInmuebles (promIdSelected) {
      const promoSelectedFull = this.promosCliente.find( e=> {
        return e.id === promIdSelected
      })
      this.inmueblesCliente = promoSelectedFull.inmuebles
      if (this.inmueblesCliente.length === 1) {
        this.inmuebleSelected = this.inmueblesCliente[0].ID_INMUEBLE
        this.getLocalizaciones(this.inmueblesCliente[0].ID_TIPO_INMUEBLE)
      }
    },
    ...mapActions({
      getTiposSolicitudes: 'configuracion/obtenerTiposSolicitud',
      getVisitTypes: 'incidencias/getVisitTypes',
      addAlert: 'alerts/add',
      getOficios: 'incidencias/getOficios',
      addVisit: 'incidencias/addVisit',
      addIncidence: 'incidencias/addIncidence',
      addPicture: 'incidencias/addPicture',
      getLocalizaciones: 'incidencias/getLocalizaciones',
      obtenerPromocionesTiposSolicitudCliente: 'configuracion/obtenerPromocionesTiposSolicitudCliente',
    }),
    async create () {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      this.$store.commit('setNewIncidenceId', null)
      this.$store.commit('setActualVisitId', null)
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        try {
          let newVisit = {
            date: this.visitDate,
            reportedBy: this.userStorage.nombre + ' ' + this.userStorage.apellidos,
            visitTypeId: this.tiposVisita, //siempre post-venta
            contactName: this.nombre,
            contactEmail: this.email,
            contactTlf: this.tlf,
            contactTlf2: this.contact,
            contactObs: this.observations,
            specialCostumerId: null,
            developmentId: this.promSelected,
            propertyId: this.inmuebleSelected,
            specialPropertyId: null,
            operationId: null,
            rolCliente: true
          }
          await this.addVisit(newVisit),
          await this.addNewIncidence()
          this.loader.hide()
          this.$router.push('/solicitudes-cliente')
        } catch (error) {
          this.loader.hide()
          this.addAlert({ texto: this.$t('errorCrearVisita') + error.message, color: 'error' })
        }
      }
    },
    async addNewIncidence () {
      // const datosIdubapi = JSON.parse(localStorage.idubapi)
      let newIncidence = {
        codigoTipoSolicitud: this.TipoSolicitud, // datosIdubapi.tiposSolicitudes[0],
        proffesionId: this.oficioSelected.length > 0 ? this.oficioSelected : null,
        proffesion2Id: null,
        description: this.description,
        obs: this.observation,
        complaint: null,
        predefinedIncidenceId: null,
        recidivist: null, // this.reincidente ? '1' : '0',
        orderTypeId: null,
        roomId: this.locationSelected,
        initialFinishDate: null,
        providerId: null,
        severityId: null,
        responsableId: null,
        notificationDate: this.fechaAviso,
        statusId: '10',
        visitId: this.getIdVisitaCliente,
        rolCliente: true
      }
      await this.addIncidence(newIncidence)
      if (this.allPics.length > 0) {
        await this.sendAllPics()
      }
    },
    addNewPicture (pic, desc) {
      console.log('ADDING NEW PICTURE FOR ID, ', this.$store.state.newIncidenceId)
      console.log('imgFile0 pic y desc', pic + ' ' + desc)
      var reader = new FileReader()
      reader.readAsDataURL(pic)
      reader.onload = () => {
        const imageBase64 = reader.result
        const arrImageSplit = imageBase64.split(',')
        const values = {
          picture: arrImageSplit[1],
          description: desc,
          name: pic.name,
          mime: pic.type,
          tipoObjetoId: 2,
          carpetaId: this.carpetaId,
          objetoId: this.getNewIncidenceId ? this.getNewIncidenceId : 'no me ha llegao na'
        }
        this.addPicture(values)
        }
    },
    sendAllPics () {
      return new Promise((resolve) => {
        this.allPics.forEach(e => {
          console.log('tengo el id de la solicitud?' ,this.getNewIncidenceId)
          console.log(e)
          resolve(this.addNewPicture(e.picture, e.description))
        })
      })
    },
    load () {
      this.$store.commit('incidencias/setAllIncidences', [])
      this.getOficios()
      this.loader.hide()
    },
    formatDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    obtenerTextoInmueble (item) {
      return item.ALIAS || item.UHEDIT
    }
  }
}
</script>

<style scoped>
</style>
